<template>
  <b-modal v-model="model" centered modal-class="modal-bb-squared" hide-footer>
    <template v-if="successData" slot="modal-header">
      <h5>{{ successData.title }}</h5>
      <p class="fs15 text-gray-700 pt-10">{{ successData.subtitle }}</p>
      <button class="close" @click="close"></button>
    </template>
    <template v-if="successData" slot="default">
      <div v-if="randomJobs && randomJobs.length">
        <div class="application-sent__title">
          <strong>We found more jobs you might like</strong>
        </div>
        <div v-for="item in randomJobs" :key="item.id" class="mb-16">
          <JobsListItem :job="item" :compact="true" :bordered="true" />
        </div>
      </div>
      <div v-else class="text-center">
        <img
          class="img-fluid"
          :src="require('~/assets/img/ilustrations/' + successData.image)"
          :width="successData.width"
        />
      </div>

      <template v-if="isCareersPage">
        <a v-if="successData.link" class="btn btn-lg w-100 mt-40" :href="successData.link">{{
          successData.label
        }}</a>
        <button v-else class="btn btn-lg w-100 mt-40" @click="close">
          {{ successData.label }}
        </button>
      </template>
      <template v-else>
        <n-link
          v-if="successData.link"
          class="btn btn-lg w-100 mt-40"
          :to="successData.link"
          @click="close"
          >{{ successData.label }}</n-link
        >
        <button v-else class="btn btn-lg w-100 mt-40" @click="close">
          {{ successData.label }}
        </button>
      </template>
    </template>
  </b-modal>
</template>

<script>
import JobsListItem from '@/components/jobs/JobsListItem';
import shuffle from 'lodash/shuffle';
import slice from 'lodash/slice';

export default {
  components: {
    JobsListItem
  },
  props: {
    successData: {
      required: true
    },
    value: {
      required: true,
      type: Boolean
    },
    related: Array,
    isCareersPage: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      }
    },
    randomJobs() {
      return slice(shuffle(this.related), 0, 3);
    }
  },
  methods: {
    close() {
      this.model = false;
    }
  }
};
</script>
<style scoped lang="scss">
.application-sent {
  &__title {
    color: $gray-700;
    margin-bottom: 25px;
    font-size: 14px;
  }
}
</style>
